module.exports = __webpack_public_path__ + "img/timbre_title.0ee82560.png";